import { render, staticRenderFns } from "./icon-image.vue?vue&type=template&id=52d6cce7"
import script from "./icon-image.vue?vue&type=script&lang=js"
export * from "./icon-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports